
export class Storage {

  static get(key: any, value: any = null) {
    const v = localStorage.getItem(key);
    if (v) {
      value = JSON.parse(v);
    }
    return value;
  }

  static set(key: any, value: any) {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
    return value;
  }

  static has(key: any) {
    let value = false;
    const v = localStorage.getItem(key);
    if (v) {
      value = true;
    }
    return value;
  }

  static remove(key: any) {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage/index.tsx